<template>
    <div>
        <div class="page-footer">
        </div>
    </div>
</template>

<script>
    export default {
        name: "index",

        data() {
            return {
                copyright: process.env.COPYRIGHT,
            };
        },
        computed: {

        },
        watch: {},
        created: function () {

        },
        methods: {

        }
    };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/footer.vue